import React from 'react'

const NoDataChart = ({ title, subtitle }) => {
  return (

    <div className='d-flex flex-column justify-content-center align-items-center h-100 p-5' style={{height:'306'}}>
      {title && <h4 className="text-center">{title}</h4>}
      {subtitle && <p className="text-center">{subtitle}</p>}
    </div>
  )
}

export default NoDataChart